export default [
  {
    path: '/admin',
    name: 'admin',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/AdminPage.vue')
  },
  {
    path: '/admin/employee-report',
    name: 'employee-report',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/EmployeeReport.vue')
  },
  {
    path: '/admin/daily-report',
    name: 'daily-report',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/DailyReport.vue')
  },
  {
    path: '/admin/time-exceeded',
    name: 'time-exceeded',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/TimeExeeded.vue')
  },
  {
    path: '/admin/today-applicants',
    name: 'today-applicants',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/TodayApplicants.vue')
  },
  {
    path: '/admin/admin-designated-position',
    name: 'admin-designated-position',
    component: () =>
        import(/* webpackChunkName: "admin" */ '@/views/admin/AdminDesignatedPosition.vue')
  },
  {
    path: '/admin/company-offers',
    name: 'company-offers',
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '@/views/admin/CompanyOffers.vue'
      )
  },
  {
    path: '/admin/company-offers/:company_id',
    name: 'company-offers-with-id',
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '@/views/admin/CompanyOffers.vue'
      )
  },
  {
    path: '/admin/employers-last-month',
    name: 'employers-last-month',
    component: () =>
      import(
        /* webpackChunkName: "admin" */ '@/views/admin/EmployersLastMonth.vue'
      )
  },
  {
    path: '/admin/stargate-log',
    name: 'stargate-log',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/StargateLog.vue')
  },
  {
    path: '/admin/chatbot-proposals',
    name: 'chatbot-proposals',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/ChatbotProposals.vue')
  },
  {
    path: '/admin/company-followup',
    name: 'company-followup',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/CompanyFollowup.vue')
  },
  {
    path: '/pipeline-funnel',
    name: 'pipeline-funnel',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/PipelineFunnel.vue')
  },
  {
    path: '/sending-policies',
    name: 'sending-policies',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/SendingPolicies.vue')
  },
  {
    path: '/blocked-candidates',
    name: 'blocked-candidates',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/BlockedCandidates.vue')
  },
  {
    path: '/admin/intake-assist',
    name: 'admin-intake-assist',
    component: () =>
      import(/* webpackChunkName: "admin" */ '@/views/admin/IntakeAssistTasks.vue')
  }
]
